import {
  GET_SOCIAL_ORGANIZATION_FEEDBACKS,
  GET_SOCIAL_ORGANIZATION_FEEDBACKS_FAILED,
  GET_SOCIAL_ORGANIZATION_FEEDBACKS_SUCCESS,
  GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
  GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_FAILED,
  GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_SUCCESS,
  UPDATE_SOCIAL_ORGANIZATION_FEEDBACK,
  UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
  UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
  RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK,
  RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
  RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
  REJECT_SOCIAL_ORGANIZATION_FEEDBACK,
  REJECT_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS,
  REJECT_SOCIAL_ORGANIZATION_FEEDBACK_FAILED,
  CLEAR_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL,
} from './actionTypes';

const initialState = {
  isLoadingGetSocialOrganizationFeedbacks: false,
  socialOrganizationFeedbacks: [],
  totalSocialOrganizationFeedbacks: 0,
  isLoadingGetSocialOrganizationFeedbackDetail: false,
  socialOrganizationFeedbackDetail: null,
  isLoadingUpdateSocialOrganizationFeedback: false,
  isLoadingResolveSocialOrganizationFeedback: false,
  isLoadingRejectSocialOrganizationFeedback: false,
};

export default function ManagerTcxhFeedback(state = initialState, action) {
  switch (action.type) {
    case GET_SOCIAL_ORGANIZATION_FEEDBACKS:
      return {
        ...state,
        isLoadingGetSocialOrganizationFeedbacks: true,
      };

    case GET_SOCIAL_ORGANIZATION_FEEDBACKS_SUCCESS:
      return {
        ...state,
        isLoadingGetSocialOrganizationFeedbacks: false,
        socialOrganizationFeedbacks: action.payload?.data || [],
        totalSocialOrganizationFeedbacks: action.payload?.total || 0,
      };

    case GET_SOCIAL_ORGANIZATION_FEEDBACKS_FAILED:
      return {
        ...state,
        isLoadingGetSocialOrganizationFeedbacks: false,
      };

    case GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL:
      return {
        ...state,
        isLoadingGetSocialOrganizationFeedbackDetail: true,
      };

    case GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetSocialOrganizationFeedbackDetail: false,
        socialOrganizationFeedbackDetail: action.payload,
      };

    case GET_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetSocialOrganizationFeedbackDetail: false,
      };

    case UPDATE_SOCIAL_ORGANIZATION_FEEDBACK:
      return {
        ...state,
        isLoadingUpdateSocialOrganizationFeedback: true,
      };

    case UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS:
    case UPDATE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED:
      return {
        ...state,
        isLoadingUpdateSocialOrganizationFeedback: false,
      };

    case RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK:
      return {
        ...state,
        isLoadingResolveSocialOrganizationFeedback: true,
      };

    case RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS:
    case RESOLVE_SOCIAL_ORGANIZATION_FEEDBACK_FAILED:
      return {
        ...state,
        isLoadingResolveSocialOrganizationFeedback: false,
      };

    case REJECT_SOCIAL_ORGANIZATION_FEEDBACK:
      return {
        ...state,
        isLoadingRejectSocialOrganizationFeedback: true,
      };

    case REJECT_SOCIAL_ORGANIZATION_FEEDBACK_SUCCESS:
    case REJECT_SOCIAL_ORGANIZATION_FEEDBACK_FAILED:
      return {
        ...state,
        isLoadingRejectSocialOrganizationFeedback: false,
      };

    case CLEAR_SOCIAL_ORGANIZATION_FEEDBACK_DETAIL:
      return {
        ...state,
        socialOrganizationFeedbackDetail: null,
      };

    default:
      return state;
  }
}
